import { createContext, useContext } from 'react';

type NavigationPromptContextValue = {
  isFormDirty: boolean;
  setIsFormDirty: (isDirty: boolean) => void;
};

const NavigationPromptContext = createContext<NavigationPromptContextValue>({
  isFormDirty: false,
  setIsFormDirty: () => {},
});

export function useNavigationPrompt() {
  return useContext(NavigationPromptContext);
}

export default NavigationPromptContext;
